<template>
	<div class="patient-view chart">
		<ChartCard :patient="patient"></ChartCard>
	</div>
</template>

<script>
import PatientView from '..'

export default {
	name: 'patient-chart',
	extends: PatientView
}
</script>
